import { render } from "./CustomPhoneInput.vue?vue&type=template&id=6a5a4286&scoped=true&ts=true"
import script from "./CustomPhoneInput.vue?vue&type=script&lang=ts"
export * from "./CustomPhoneInput.vue?vue&type=script&lang=ts"

import "./CustomPhoneInput.vue?vue&type=style&index=0&id=6a5a4286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5a4286"]])

export default __exports__